<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3592_1951)">
      <path
        d="M9.41334 9.41332C9.23024 9.60982 9.00944 9.76743 8.76411 9.87674C8.51877 9.98605 8.25394 10.0448 7.9854 10.0496C7.71686 10.0543 7.45011 10.0049 7.20108 9.90432C6.95204 9.80373 6.72582 9.65401 6.5359 9.46409C6.34599 9.27418 6.19627 9.04795 6.09568 8.79892C5.99509 8.54988 5.94569 8.28314 5.95043 8.0146C5.95517 7.74606 6.01394 7.48122 6.12326 7.23589C6.23257 6.99056 6.39017 6.76976 6.58667 6.58666M11.96 11.96C10.8204 12.8287 9.43274 13.3099 8 13.3333C3.33334 13.3333 0.666672 7.99999 0.666672 7.99999C1.49593 6.45459 2.6461 5.1044 4.04 4.03999L11.96 11.96ZM6.6 2.82666C7.05889 2.71924 7.52871 2.66555 8 2.66666C12.6667 2.66666 15.3333 7.99999 15.3333 7.99999C14.9287 8.75706 14.446 9.46982 13.8933 10.1267L6.6 2.82666Z"
        stroke="#6C6D84"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.666672 0.666667L15.3333 15.3333"
        stroke="#6C6D84"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3592_1951">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
